import React, { createContext, useContext, useState, useEffect } from 'react'

export const FeatureFlagContext = createContext({})

export const FeatureFlagConsumer = FeatureFlagContext.Consumer

export const FeatureFlagProvider = ({ children }) => {
  const [isV2enabled, setIsV2Enabled] = useState(false)

  useEffect(() => {
    let isV2EnabledLocal
    if (typeof window !== 'undefined') {
      isV2EnabledLocal = localStorage.getItem('v2Enabled')
    }
    if (process.env.NEXT_PUBLIC_V2_FEATURE_FLAG || isV2EnabledLocal) {
      setIsV2Enabled(true)
    }
  }, [])

  return (
    <FeatureFlagContext.Provider
      value={{
        isV2enabled,
      }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export const useFeatureFlag = () => {
  return useContext(FeatureFlagContext)
}
